function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_REQUEST = "GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_REQUEST";
export var GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_SUCCESS = "GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_SUCCESS";
export var GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_FAILURE = "GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_FAILURE";
export var RESET_GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID = "RESET_GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID";

// Fetches add-to-cart modal for a particular user and followee username from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
var fetchOperationFormByInvestmentItemIdAndUserId = function fetchOperationFormByInvestmentItemIdAndUserId(investmentItemId, userId) {
  var queryString = urlSearchParams({
    investmentItemId: investmentItemId,
    userId: userId
  });
  return _defineProperty({
    investmentItemId: investmentItemId,
    userId: userId
  }, CALL_API, {
    types: [GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_REQUEST, GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_SUCCESS, GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_FAILURE],
    endpoint: "operationForms/search/findByInvestmentItemIdAndUserId".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};

// Fetches add-to-cart modal for a particular user and followee username unless it is cached.
// Relies on Redux Thunk middleware.
export var loadOperationFormByInvestmentItemIdAndUserId = function loadOperationFormByInvestmentItemIdAndUserId(investmentItemId, userId, forceUpdate) {
  return function (dispatch, getState) {
    var key = [investmentItemId, userId].join("-");
    var userView = getState().entities.operationForms.byInvestmentItemIdAndUserId[key];
    if (userView && !forceUpdate) return null;
    return dispatch(fetchOperationFormByInvestmentItemIdAndUserId(investmentItemId, userId));
  };
};